
import "./player.scss";
import PlayerRight from "../../features/player/PlayerRight";
import ScrollToTop from "../../shared/components/common/ScrollToTop";
import PlayerInfoSearch from "../../features/player/PlayerInfoSearch";
import PlayerInfo from "../../features/player/PlayerInfo";
import PlayerInfoModify from "../../features/player/PlayerInfoModify";
import React, { useContext, useEffect, useState } from "react";
import { defaultPlayerData, PlayerContext } from "../../shared/contexts/playerContext";
import { AuthContext } from "../../shared/contexts/authContext";
import { DarkModeContext } from "../../shared/contexts/darkModeContext";
import { USER_STATE } from "../../shared/utils/enum";
import { useNavigate } from "react-router-dom";
import { Grid, Space, Splitter } from 'antd';
import { internalApi } from "../../common/axios";
import { buildUrl } from "../../shared/utils/net";

const SPLIT_RATIO_KEY = 'player_split_ratio';
const loadSplitRatio = () => localStorage.getItem(SPLIT_RATIO_KEY) || '45%';

const Player = () => {
    const { playerData, setPlayerData } = useContext(PlayerContext);
    const { currentUser } = useContext(AuthContext);
    const { darkMode } = useContext(DarkModeContext);
    const [isChange, setIsChange] = useState(false);
    const [defaultState, setDefaultState] = useState(playerData.userState ?? USER_STATE.DEFAULT);
    const navigate = useNavigate();
    const screens = Grid.useBreakpoint();
    const [splitRatio] = useState(loadSplitRatio);

    const isHorizontal = !!screens.xl;

    const handleResizeEnd = ([first, second]) => {
        if (!isHorizontal || !first || !second) return;
        localStorage.setItem(SPLIT_RATIO_KEY, `${(first / (first + second) * 100).toFixed(2)}%`);
    };

    const refreshPlayerData = async () => {
        if (!playerData.pid) return;
        try {
            const url = buildUrl('player', {
                type: 'pid',
                value: playerData.pid,
                target: currentUser.target
            });
            const res = await internalApi.get(url);
            if (res.data.player) {
                setPlayerData(res.data.player);
                setDefaultState(res.data.player.userState);
            }
        } catch (err) {
            console.error('플레이어 정보 갱신 실패:', err);
        }
    };

    useEffect(() => {
        setPlayerData(defaultPlayerData);
    }, []);

    useEffect(() => {
        if (playerData.pid === '') {
            navigate("/player", { replace: true });
        }
    }, [playerData]);

    return (
            <div className={`player-main ${darkMode ? 'dark-theme' : 'light-theme'}`}>
                {/* 메인 컨텐츠 */}
                <div style={{ padding: '0 24px 24px' }}>
                    <Splitter
                        layout={isHorizontal ? 'horizontal' : 'vertical'}
                        onResizeEnd={handleResizeEnd}
                        style={{ height: 'calc(100vh - 200px)' }}
                    >
                        {/* 왼쪽 영역 - 플레이어 정보 (드래그로 너비 조절) */}
                        <Splitter.Panel defaultSize={splitRatio} min="25%" max="75%">
                            <div className="player-left-section" style={{ paddingRight: isHorizontal ? 12 : 0 }}>
                                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                                    {/* 검색 섹션 */}
                                    <div className="search-section">
                                        <PlayerInfoSearch
                                            db={currentUser.target}
                                            setPlayerData={setPlayerData}
                                            setDefaultState={setDefaultState}
                                        />
                                    </div>

                                    {/* 플레이어 정보 섹션 */}
                                    <div className="info-section">
                                        <PlayerInfo
                                            playerData={playerData}
                                            setPlayerData={setPlayerData}
                                            setIsChange={setIsChange}
                                            defaultState={defaultState}
                                            isCopy={false}
                                        />
                                    </div>

                                    {/* 플레이어 수정 섹션 */}
                                    <div className="modify-section">
                                        <PlayerInfoModify
                                            playerData={playerData}
                                            setPlayerData={setPlayerData}
                                            isChange={isChange}
                                            setIsChange={setIsChange}
                                            setDefaultState={setDefaultState}
                                            onRefresh={refreshPlayerData}
                                        />
                                    </div>
                                </Space>
                            </div>
                        </Splitter.Panel>

                        {/* 오른쪽 영역 - 플레이어 상세 정보 */}
                        <Splitter.Panel>
                            <div className="player-right-section" style={{ paddingLeft: isHorizontal ? 12 : 0 }}>
                                <div className="right-panel-wrapper">
                                    <PlayerRight />
                                </div>
                            </div>
                        </Splitter.Panel>
                    </Splitter>
                </div>

                <ScrollToTop />
            </div>
    );
}

export default Player;